import React, { Component } from 'react';

//import HeaderImage from "../../assets/images/bluechip.svg";

//components
import Navigation from 'modules/navigation';

//images
import HeaderImage from 'assets/images/canlease-logo.png';

import dispatcher from 'dispatcher';

//style
import './Header.css';

export default class Header extends React.Component {
    logout = () => {
        console.log('displatching ');
        dispatcher.dispatch({ type: 'LOGGED_OUT' });
    };

    render() {
        const nav = this.props.appState.auth ? <Navigation /> : '';
        const logout = this.props.appState.auth ? (
            <span>
                <a onClick={this.logout}>logout</a>
            </span>
        ) : (
            ''
        );
        return (
            <header>
                {logout}
                <img src={HeaderImage} />
                {nav}
            </header>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/header/Header.jsx